<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" :max-width="maxWidth || '500px'" persistent>
    <v-card class="custom-dialog-card">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" size="32" class="mr-2">{{ icon }}</v-icon>
        <span class="text-h6 font-weight-bold">{{ title }}</span>
        <v-spacer></v-spacer>
        <v-btn icon flat @click="$emit('update:modelValue', false)" class="close-btn" title="Fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <slot></slot> <!-- Para o conteúdo do formulário -->
      </v-card-text>
      <v-card-actions v-if="!hideActions">
        <slot name="actions">
          <v-btn text @click="$emit('update:modelValue', false)">Cancelar</v-btn>
          <v-spacer />
          <v-btn size="large" variant="tonal" color="primary" @click="$emit('salvar')" :loading="loading">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['modelValue', 'title', 'icon', 'loading', 'hideActions', 'maxWidth']
}
</script>